import { configureStore } from '@reduxjs/toolkit'
import locationReducer from '../features/location/locationCab'
import userReducer from '../features/auth/agence'
export default configureStore({
  reducer: {
    location: locationReducer,
    user: userReducer,
  },
})